/* Для специалистов */

import { scrollToElement } from "./Util";

let storePromise;
let $personalForm = $('.js-personal-data-form');
let currentUserPhone = $personalForm.find('.js-sms-phone-field').val();

$personalForm.data('current-phone', currentUserPhone);

if (App.H.hasClass('page-for-specialists-personal')) {
    let $confirmEmailLink = $('.js-confirm-email-link');
    let $confirmEmailText = $('.js-confirm-email-text');

    $('.js-change-form').on('click', function(e) {
        let $currForm = $(this).closest('.js-personal-form');

        $currForm.addClass('_edit');
        $personalForm.removeClass('phone-is-accept');
        scrollToElement($currForm);

        $currForm.find('.js-submit').removeClass('_disabled').removeAttr('disabled');

        // сделана загрузка карты по клику на таб
        // if ($currForm.find('.js-map-pharmacies').length) {
        //     if (!storePromise) {
        //         storePromise = import('/_src/js/store/_store.js');
        //     }
        //     storePromise.then(({pharmaciesMap}) => {
        //         pharmaciesMap();
        //     });
        // }

        e.preventDefault();
    });

    $confirmEmailLink.on('click', function(e) {
        e.preventDefault();

        $confirmEmailLink.attr('disabled', true);

        $.ajax(
            $confirmEmailLink.data('url'), {
                data: {
                    econfirm: $('[name="USER_EMAIL"]').val()
                },
                success: function(responce) {
                    if (responce.success) {
                        $confirmEmailLink.toggle();
                        $confirmEmailText.toggle();
                    }

                    $confirmEmailLink.attr('disabled', false);
                }
            }
        );
    });
}

App.W.on('load', function() {
    if ($personalForm.find('[data-email]').val() !== '' || App.H.is('.no-user-email')) {
        $('[data-popup="requiredEmail"]').trigger('click');
    }
});

export function savePersonalCheckingPhone(form) {
    form.closest('.js-common-popup').find('.js-common-popup-close').trigger('click');
    form.find('.js-submit').removeClass('_disabled').removeAttr('disabled');
    $personalForm.find('.js-submit').trigger('click');
    $personalForm.data('current-phone', $personalForm.find('.js-sms-phone-field').val());
}

export function userSetEmail() {
    let $requiredForm = $('.js-required-email-form');
    let $emailField = $requiredForm.find('[data-email]').length ? $requiredForm.find('[data-email]') : $requiredForm.find('[type="email"]');
    let email = $emailField.val();

    $('.js-personal-email-field').html(email);
    $personalForm.find('[data-email]').val(email);
    $personalForm.find('[data-email]').closest('.js-input-wrap').addClass('_filled');
}


function personalFormUpdate(form) {
    let $currPersonalForm = form.closest('.js-personal-form');

    form.find('.js-field-input').each(function(index, el) {
        let val = $(el).find(':selected').length ? $(el).find(':selected').html() : $(el).val();

        val = val ? val : window.validateMessages.emptyfield;
        $currPersonalForm.find('.js-field-text').eq(index).html(val);
    });
}

export function closePersonalForm(form) {
    let $currPersonalForm = form.closest('.js-personal-form');

    if (form.is('[data-replace-fields]')) {
        personalFormUpdate(form);
    }

    $currPersonalForm.removeClass('_edit');
    //scrollToElement($currPersonalForm);
}


export function setRequiredField($input, isRequire) {
    let $label = $input.closest('.js-input-wrap').find('.form__prelabel');
    let $errorLabel = $input.closest('.js-input-wrap').find('[data-label]');
    let labelVal = $label.html();

    /*if ($input.val() === '') {
        $input.removeClass('_filled _notvalidated _error');
    }*/

    // если обязательное
    if (isRequire) {
        if ($input.val() === '') {
            $input.addClass('_notvalidated _error');
        }

        if (!$input.is('[data-required]')) {
            $input[0].setAttribute('data-required', true);
        }

        $input.removeClass('_filled');
        $label.html(labelVal.indexOf('*') <= 0 ? labelVal + '*' : labelVal);

        if ($input.is('.js-mask-phone') && !$input.val()) {
            $errorLabel.text($errorLabel.text().length > 0 ? $errorLabel.text() : window.validateMessages.required);
            $input.parent().addClass('_error');
        }
    } else {
        //$input.trigger('change');
        $input[0].removeAttribute('data-required');
        $label.html(labelVal.split('*')[0]);
        $input.addClass('_filled').removeClass('_error')
            .parent().removeClass('_error');
    }

    $input.trigger('change');
}

/* приводт телефон к формату 79121234567 */
export function formatPhone(phone) {
    let arrSymbols = ['(', ')', '-', '+', ' '];

    for (let i = 0; i < arrSymbols.length; i++) {
        phone = phone.split(arrSymbols[i]).join('');
    }

    return phone;
}

/* для формы ЛК: проверяет если номер телефона в форме и номер телефона а атрибуте формы совпадают,
значит телефон не меняося и отправлять СМС дял проверки не надо */
export function checkCurrentPhoneValue(form) {
    if (form.find('.js-sms-phone-field').length > 0) {
        let lastPhone = formatPhone(form.data('current-phone'));
        let currentPhone = formatPhone(form.find('.js-sms-phone-field').val());

        if (lastPhone === currentPhone) {
            $('[data-sms-confirmed-form]').addClass('phone-is-accept');
        }
    }
}
